/**
 * Spec filter operator symbols sent to API: =, <, >, <=, >=
 */
export type SpecOperator = '=' | '<' | '>' | '<=' | '>=';

/**
 * Draft/applied filter state for listing search.
 * Maps to API ListingQueryModel; used by useListingSearch and filter UI.
 * specOperators: per-constraint key; for numeric use '>=', '<=', '=' (min/max/exact).
 */
export interface ListingFilterState {
  topCategoryId: number | null;
  secondaryCategoryId: number | null;
  productTypeId: number | null;
  conditionId: number | null;
  cityId: number | null;
  districtId: number | null;
  isNew: boolean | null;
  price: {
    lowerBound?: number | null;
    upperBound?: number | null;
    exactMatch?: number | null;
  };
  specValues: Record<string, string>;
  specOperators: Record<string, SpecOperator>;
}

export const defaultListingFilterState: ListingFilterState = {
  topCategoryId: null,
  secondaryCategoryId: null,
  productTypeId: null,
  conditionId: null,
  cityId: null,
  districtId: null,
  isNew: null,
  price: {},
  specValues: {},
  specOperators: {},
};
